import React from 'react'

const Loader = () => {
  return (
    <div className="flex items-center justify-center min-h-screen ">
    <div className="loader">
    <div className="train">
    <div className="blue"></div>
      <div className="red"></div>
      <div className="yellow"></div>
      <div className="green"></div>
      <div className="blue"></div>
      <div className="red"></div>
      <div className="yellow"></div>
      <div className="green"></div>
      <div className="blue"></div>
      <div className="red"></div>
      <div className="yellow"></div>
      <div className="green"></div>
      <div className="blue"></div>
      <div className="red"></div>
      <div className="yellow"></div>
      <div className="green"></div>
      <div className="blue"></div>
      <div className="red"></div>
      <div className="yellow"></div>
      <div className="green"></div>
      <div className="blue"></div>
      <div className="red"></div>
      <div className="yellow"></div>
      <div className="green"></div>
    </div>
  </div>
  </div>

  )
}

export default Loader